export default "__VITE_PUBLIC_ASSET__cd2e3d93__"